<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
      <!-- ViewTitleBox -->
      <div class="ibox-tools view-title">
        <h1 class="info-menu view-name">
          <img src="static/img/assets/nav_notice_on.png" alt="">
          {{$t('noticeSettingDetailTitle')}}
        </h1>
        <span class="info-right">
              <button class="btn btn-danger" @click="cancelEdit">{{$t('cancelStr')}}</button>
              <button class="btn btn-success"  @click="updateSetting">{{$t('saveStr')}}</button>
        </span>
      </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
<div class="ibox">
<div class="ibox-content notice-setting">
    <div class="ibox-content search-resultview">
        <ul v-for="item of noticeSettingsExport.settingKey" >
            <li  class="flex-box fl-between group-item">
            <div>
                <div class="search-userinfo">
                  <span class="search-username">{{$t('noticeSettingStr.'+item)}}</span>
                </div>
            </div>
              <toggle-button v-model="settingInfo[item]"
              :value=settingInfo[item]
              :color="{checked: '#E85050', unchecked: '#7AE197'}"
              :labels= "{checked: 'ON', unchecked: 'OFF'}"
              :sync="false"
              :width="75"/>
           </li>
           </ul>
        </div>
    </div>
</div>
        </section>
        </article>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NoticeItem from '@/components/Notice/NoticeItem'
import NoticeDropDown from '@/components/Notice/NoticeDropDown'
import { noticeSettingsExport, liteMode } from '@/main.js'
export default {
  name: '',
  components: {
    NoticeItem,
    NoticeDropDown
  },
  data: function () {
    return {
      noticeSettingsExport: noticeSettingsExport,
      tag: 'progress',
      open: false,
      settingInfo: {}
    }
  },
  created: function () {
    if (liteMode) {
      for (let notice in this.noticeSettingsExport.settingKey) {
        if (this.noticeSettingsExport.settingKey[notice].includes('Objective')) {
          this.noticeSettingsExport.settingKey.splice(notice, 2)
        }
      }
    }
    if (this.getCurrentNoticeSettings.noticeMessaged === true || this.getCurrentNoticeSettings.noticeMessaged === false) {
      this.settingInfo = JSON.parse(JSON.stringify((this.getCurrentNoticeSettings)))
    } else {
      this.settingInfo = this.noticeSettingsExport.settingInfo
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'NoticeSettingDetail'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('noticeSettings/', [
      'getCurrentNoticeSettings'
    ])
  },
  methods: {
    ...mapActions('noticeSettings/', {
      setCurrentNoticeSettnges: 'SET_CURRENT_NOTICESETTNGES'
    }),
    updateSetting: function () {
      delete (this.settingInfo['.key'])
      this.setCurrentNoticeSettnges(this.settingInfo)
      this.$router.push({ name: 'NoticeSetting' })
    },
    cancelEdit () {
      const $t = this.$t
      this.$swal({
        // sweetAlartの処理
        title: $t('popTitleStrType'),
        text: $t('confirmInputDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        width: '35rem',
        position: 'center',
        allowOutsideClick: false,
        padding: '2rem'
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: 'NoticeSetting' })
        }
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/notice/NoticeSettingDetail.vue